import { UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class FmPasswordMatcher implements ErrorStateMatcher {
    isErrorState(control: UntypedFormControl | null): boolean {
        return !!(control && (control.invalid || control.parent.hasError('passwordConfirmation')) && (control.dirty || control.touched));
    }
}
